module.exports = __webpack_public_path__ + "static/divider13-8599df16241d7c09f4fc74a4ea927db4.svg";